module.exports = __webpack_public_path__ + "img/window-minimize.20f1cd37.svg";